import { clstx } from '@payaca/utilities/cvaMerge';
import React from 'react';

import Card, { CardProps } from './Card';

/**
 * A Card that navigates. Renders an `a` by default; pass `as={Link}` with `to`
 * for in-app navigation.
 */
const CardAnchor = <E extends React.ElementType = 'a'>(props: CardProps<E>) => {
  const { className, children, ...rest } = props;

  return (
    <Card<React.ElementType>
      as="a"
      className={clstx(
        // oxlint-disable-next-line payaca/no-tailwind-arbitrary-values
        'font-normal text-[var(--tw-prose-root)] hover:cursor-pointer hover:bg-gray-100 hover:no-underline',
        className
      )}
      {...rest}
    >
      {children}
    </Card>
  );
};

export default CardAnchor;
